import { BlurView } from 'expo-blur';
import { Body2Reg } from '../../config/designSystem/typography';
import { COLORS } from '../../config/designSystem/Colors';
import { EvolunoCheck } from '../../assets/images/Icons/Check/EvolunoCheck';
import { SPACING } from '../../config/designSystem/Spacing';
import { View } from 'react-native-animatable';
import { useStores } from '../../hooks/useStores';


export const HEIGHT_PROGRESS_BAR = SPACING['sp-8'];

export const ActivePath = () => {
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE.PATH;


  return(
    <View style={{
      borderRadius: SPACING['sp-24'],
      overflow: 'hidden',
      zIndex:4,
      backgroundColor: COLORS.surface['primary-dark']+ '80'}}>
      <BlurView
        style={{
          flexDirection: 'row',

          paddingVertical: SPACING['sp-4'],
          paddingHorizontal: SPACING['sp-8'],
          columnGap: SPACING['sp-4'],
          backgroundColor: COLORS.surface['primary-dark']+'00',
          alignItems:'center'

        }}
        intensity={24}

      >
        <Body2Reg color={COLORS.content['inverse-primary']}>{labels?.ACTIVE_PATH}</Body2Reg>
        <EvolunoCheck size={16} color={COLORS.surface.primary}/>
      </BlurView>
    </View>
  );
};